/* ============================================================================
   assets/ll-plush-hub.js
   The behaviour for sections/ll-plush-hub.liquid.
   ============================================================================

   This used to be an inline <script> in the section. Inline meant it was part
   of the HTML document: re-rendered by Shopify and re-sent to the browser on
   every single page view, never cached, and counted against the time the
   server spends building the page. On the homepage the six hub sections came
   to 127 KB of the 1.8 MB document.

   The code is byte-identical on every render, so it belongs in an asset the
   browser can cache once and reuse across the whole site.

   WHAT CHANGED, AND WHAT DID NOT. The section used to bake its own id into the
   script as `var ROOT_ID = "{{ uid }}"`, which is the single reason this could
   not be a static file. One asset now serves every instance: it finds each
   root by its [data-llpz-root] marker and reads the id from
   data-section-id, which the markup already carried. Everything inside
   initInstance is the original code, unchanged.

   The per-instance JSON config block stays in the section, because that is
   real per-instance data rather than code.
============================================================================ */
(function () {
  /* Two instances of the same section put two identical <script src> tags on
     the page, and the browser runs both. */
  if (window.__llPlushHubJS) return;
  window.__llPlushHubJS = true;

  /* ---- block 1 of 2, extracted verbatim ---- */
  (function () {
    var inited = {};

    function initInstance(ROOT_ID) {
      function boot(root) {
          if (!root || root.dataset.llpzReady === '1') return;
          root.dataset.llpzReady = '1';

          var cfg = {};
          try { cfg = JSON.parse(root.querySelector('[data-llpz-config]').textContent); } catch (e) { cfg = {}; }

          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var live = root.querySelector('[data-live]');
          var K_WATCH = 'll_watchlist';       /* shared with the TCG + pre-order hubs */

          function say(m) { if (live) live.textContent = m; }
          function readJSON(store, key, fb) {
            try { var v = store.getItem(key); return v ? JSON.parse(v) : fb; } catch (e) { return fb; }
          }
          function writeJSON(store, key, val) { try { store.setItem(key, JSON.stringify(val)); } catch (e) {} }
          function isArr(v) { return Object.prototype.toString.call(v) === '[object Array]'; }
          function rootUrl() {
            return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          }

          /* ---------------- toast ---------------- */
          var toast = root.querySelector('[data-toast]');
          var toastText = root.querySelector('[data-toast-text]');
          var toastLink = root.querySelector('[data-toast-link]');
          var toastTimer = null;
          function showToast(msg, href, linkText) {
            if (!toast) return;
            toastText.textContent = msg;
            if (toastLink) {
              toastLink.hidden = false;
              toastLink.href = href || cfg.cartUrl || '/cart';
              toastLink.textContent = linkText || 'View cart';
            }
            toast.classList.add('is-on');
            clearTimeout(toastTimer);
            toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
            say(msg);
          }

          var cards = Array.prototype.slice.call(root.querySelectorAll('[data-grid] [data-card]'));
          var grid = root.querySelector('[data-grid]');
          var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-chip]'));
          var sizeChips = Array.prototype.slice.call(root.querySelectorAll('[data-size]'));
          var noRes = root.querySelector('[data-no-results]');
          var sortSel = root.querySelector('[data-sort]');

          var charChips = Array.prototype.slice.call(root.querySelectorAll('[data-char]'));
          var charRow = root.querySelector('[data-chars-row]');
          var sizeRow = root.querySelector('[data-size-row]');

          var activeCats = [];     /* union — Plushies + Figures together is useful */
          var activeSize = 'all';
          var activeChar = 'all';  /* one at a time: nobody wants Pikachu OR Gengar */

          function tokensOf(c) { return (c.getAttribute('data-tokens') || '').split(/\s+/).filter(Boolean); }
          function charsOf(c) { return (c.getAttribute('data-chars') || '').split(/\s+/).filter(Boolean); }

          /* ---------------- watchlist ---------------- */
          var watchChip = root.querySelector('[data-watch-chip]');
          var watchCount = root.querySelector('[data-watch-count]');
          var wv = root.querySelector('[data-watch-view]');
          var wvGrid = root.querySelector('[data-watch-grid]');
          var wvEmpty = root.querySelector('[data-wv-empty]');
          var wvCount = root.querySelector('[data-wv-count]');
          var wvClose = root.querySelector('[data-wv-close]');

          function readWatch() {
            var l = readJSON(localStorage, K_WATCH, null);
            if (isArr(l)) return l;
            var old = readJSON(localStorage, 'll_preorder_watch', []);
            if (isArr(old) && old.length) { writeWatch(old); return old; }
            return [];
          }
          function writeWatch(l) {
            var clean = (l || []).slice(0, 100);
            writeJSON(localStorage, K_WATCH, clean);
            writeJSON(localStorage, 'll_preorder_watch', clean);
            var cid = root.getAttribute('data-customer-id');
            if (cid) writeJSON(localStorage, 'll_watchlist_c_' + cid, clean);
            try {
              document.dispatchEvent(new CustomEvent('ll:watchlist:change', { detail: { list: clean } }));
            } catch (e) {}
            return clean;
          }
          function unwatchHandle(handle) {
            var list = readWatch().filter(function (h) { return h !== handle; });
            writeWatch(list);
            try {
              var snaps = readJSON(localStorage, 'll_watchlist_snap', {});
              if (snaps && typeof snaps === 'object') {
                delete snaps[handle];
                writeJSON(localStorage, 'll_watchlist_snap', snaps);
              }
            } catch (e) {}
            if (window.LLWatchlistLive && typeof window.LLWatchlistLive.stop === 'function') {
              window.LLWatchlistLive.stop(handle);
            }
            return list;
          }

          function paintWatch() {
            var list = readWatch();
            root.querySelectorAll('[data-card]').forEach(function (card) {
              var bell = card.querySelector('[data-watch]');
              if (bell) bell.setAttribute('aria-pressed', list.indexOf(card.getAttribute('data-handle')) > -1 ? 'true' : 'false');
            });
            if (watchChip) {
              watchChip.hidden = list.length === 0;
              watchChip.setAttribute('data-has', list.length ? '1' : '0');
              if (watchCount) watchCount.textContent = list.length;
              if (!list.length) watchChip.setAttribute('aria-pressed', 'false');
            }
          }

          function money(cents) {
            var v = (Number(cents) || 0) / 100;
            try {
              return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
                { style: 'currency', currency: cfg.currency || 'GBP' }).format(v);
            } catch (e) { return v.toFixed(2); }
          }

          function fetchProduct(handle) {
            var key = 'll_wv_' + handle;
            var hit = readJSON(sessionStorage, key, null);
            if (hit && hit.t && (Date.now() - hit.t) < 600000) return Promise.resolve(hit.p);
            return fetch(rootUrl() + 'products/' + handle + '.js')
              .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
              .then(function (p) { writeJSON(sessionStorage, key, { t: Date.now(), p: p }); return p; });
          }

          function wvCard(p) {
            var el = document.createElement('article');
            el.className = 'llpz__card';
            el.setAttribute('data-card', '');
            el.setAttribute('data-handle', p.handle);
            var url = rootUrl() + 'products/' + p.handle;
            el.setAttribute('data-url', url);
            el.setAttribute('data-title', p.title || '');

            var variant = null;
            for (var i = 0; i < (p.variants || []).length; i++) {
              if (p.variants[i].available) { variant = p.variants[i]; break; }
            }
            if (variant) el.setAttribute('data-vid', variant.id);
            var multi = (p.variants || []).length > 1;
            el.setAttribute('data-multi', multi ? 'true' : 'false');

            var img = p.featured_image || (p.images && p.images[0]) || '';
            if (img && img.indexOf('//') === 0) img = 'https:' + img;

            var cta;
            if (!p.available) {
              cta = '<a class="llpz__btn llpz__btn--ghost" href="' + url + '"><span class="llpz__btn-t">' + (cfg.soldOutLabel || 'Sold out') + '</span></a>';
            } else if (multi) {
              cta = '<a class="llpz__btn llpz__btn--ghost" href="' + url + '"><span class="llpz__btn-t">' + (cfg.optionsLabel || 'Choose options') + '</span></a>';
            } else {
              cta = '<button type="button" class="llpz__btn" data-add><span class="llpz__spin" aria-hidden="true"></span>' +
                    '<span class="llpz__btn-t">' + (cfg.addLabel || 'Add') + '</span></button>';
            }

            el.innerHTML =
              '<a class="llpz__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
                (img ? '<img class="is-main" src="' + img + '" alt="" width="420" height="420" loading="lazy" decoding="async">' : '') +
              '</a>' +
              '<div class="llpz__body">' +
                '<h3 class="llpz__name"><a href="' + url + '"></a></h3>' +
                '<span class="llpz__price">' + money(p.price) + '</span>' +
              '</div>' +
              '<div class="llpz__cta">' + cta +
                '<button type="button" class="llpz__bell" data-watch aria-pressed="true" aria-label="Remove from watchlist">' +
                '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a6 6 0 0 0-6 6v3.6l-1.7 3.1A1 1 0 0 0 5.2 16h13.6a1 1 0 0 0 .9-1.3L18 11.6V8a6 6 0 0 0-6-6Zm0 20a3 3 0 0 0 2.8-2H9.2A3 3 0 0 0 12 22Z"/></svg>' +
                '</button>' +
              '</div>';
            /* textContent — a product title is untrusted markup. */
            el.querySelector('.llpz__name a').textContent = p.title || p.handle;
            var im = el.querySelector('img');
            if (im) im.alt = p.title || '';
            return el;
          }

          function renderWatchView() {
            if (!wv || !wvGrid) return;
            var list = readWatch();
            if (wvCount) wvCount.textContent = list.length;
            wvGrid.innerHTML = '';
            if (!list.length) { if (wvEmpty) wvEmpty.setAttribute('data-show', '1'); return; }
            if (wvEmpty) wvEmpty.setAttribute('data-show', '0');
            wvGrid.innerHTML = '<p class="llpz__wv-skel">Loading your saved pieces…</p>';

            Promise.all(list.slice(0, 24).map(function (h) {
              return fetchProduct(h).catch(function () { return null; });
            })).then(function (items) {
              wvGrid.innerHTML = '';
              var gone = [], shown = 0;
              items.forEach(function (p, i) {
                if (!p) { gone.push(list[i]); return; }
                wvGrid.appendChild(wvCard(p));
                shown++;
              });
              if (gone.length) {
                var kept = readWatch().filter(function (h) { return gone.indexOf(h) === -1; });
                writeWatch(kept); paintWatch();
                if (wvCount) wvCount.textContent = kept.length;
              }
              if (!shown && wvEmpty) wvEmpty.setAttribute('data-show', '1');
            });
          }

          function wvOpen() { return wv && !wv.hidden; }
          function openWV() {
            if (!wv) return;
            wv.hidden = false;
            if (grid) grid.hidden = true;
            if (watchChip) watchChip.setAttribute('aria-pressed', 'true');
            renderWatchView();
            say('Showing your watchlist');
          }
          function closeWV() {
            if (!wv) return;
            wv.hidden = true;
            if (grid) grid.hidden = false;
            if (watchChip) watchChip.setAttribute('aria-pressed', 'false');
            say('Back to browsing');
          }
          if (watchChip) watchChip.addEventListener('click', function () { wvOpen() ? closeWV() : openWV(); });
          if (wvClose) wvClose.addEventListener('click', closeWV);

          root.addEventListener('click', function (e) {
            var bell = e.target.closest('[data-watch]');
            if (!bell || !root.contains(bell)) return;
            e.preventDefault();
            e.stopPropagation();
            var card = bell.closest('[data-card]');
            var handle = card.getAttribute('data-handle');
            var list = readWatch();
            var at = list.indexOf(handle);
            if (at > -1) {
              unwatchHandle(handle); paintWatch();
              if (wvOpen()) renderWatchView();
              say('Removed from your watchlist');
            } else {
              list.unshift(handle); writeWatch(list); paintWatch();
              showToast(
                cfg.watchAdded || 'Saved to your watchlist',
                cfg.watchUrl || '/pages/watchlist',
                cfg.watchLinkLabel || 'View watchlist'
              );
            }
          });

          var K_TIP = 'll_watchlist_tip_seen';
          var tipEl = root.querySelector('[data-watch-tip]');
          var tipDismiss = root.querySelector('[data-watch-tip-dismiss]');
          function tipSeen() {
            try { return localStorage.getItem(K_TIP) === '1'; } catch (e) { return true; }
          }
          function hideAllTips() {
            document.querySelectorAll('[data-watch-tip]').forEach(function (el) { el.hidden = true; });
          }
          function markTipSeen() {
            try { localStorage.setItem(K_TIP, '1'); } catch (e) {}
            hideAllTips();
            try { document.dispatchEvent(new CustomEvent('ll:watchlist:tip-dismissed')); } catch (e) {}
          }
          if (tipEl && !tipSeen()) tipEl.hidden = false;
          if (tipDismiss) tipDismiss.addEventListener('click', markTipSeen);
          document.addEventListener('ll:watchlist:tip-dismissed', hideAllTips);

          function syncWatchFromStore() {
            paintWatch();
            if (wvOpen()) {
              if (!readWatch().length) closeWV();
              else renderWatchView();
            }
          }
          function onWatchStorage(ev) {
            if (!ev || !ev.key) return;
            if (ev.key === K_TIP && ev.newValue === '1') hideAllTips();
            if (ev.key === K_WATCH || ev.key === 'll_preorder_watch' || (ev.key.indexOf && ev.key.indexOf('ll_watchlist_c_') === 0)) {
              syncWatchFromStore();
            }
          }
          document.addEventListener('ll:watchlist:change', syncWatchFromStore);
          window.addEventListener('storage', onWatchStorage);

          /* ---------------- filtering ---------------- */
          function apply() {
            var shown = 0;
            cards.forEach(function (card) {
              var ok = true;
              if (activeCats.length) {
                ok = false;
                var t = tokensOf(card);
                for (var i = 0; i < activeCats.length; i++) {
                  if (t.indexOf(activeCats[i]) > -1) { ok = true; break; }
                }
              }
              if (ok && activeSize !== 'all') ok = card.getAttribute('data-band') === activeSize;
              if (ok && activeChar !== 'all') ok = charsOf(card).indexOf(activeChar) > -1;
              card.hidden = !ok;
              if (ok) shown++;
            });
            if (noRes) noRes.setAttribute('data-show', shown === 0 ? '1' : '0');
          }

          /* Empty controls are REMOVED, not greyed out. A tile reading "None in
             stock" and a size nobody can press are dead weight at the top of the
             page: they take the width of a live control, and a row of them reads as
             a broken filter rather than as stock information.

             Counted against the WHOLE grid and only at start-up, never against what
             is currently on screen. Recounting after a filter would delete the
             control that undoes it, and strand the shopper on an empty page. */
          function counts() {
            tiles.forEach(function (tile) {
              var token = tile.getAttribute('data-token');
              var n = cards.filter(function (c) { return tokensOf(c).indexOf(token) > -1; }).length;
              var out = tile.querySelector('[data-chip-n]');
              if (out) out.textContent = n === 1 ? '1 item' : n + ' items';
              tile.hidden = n === 0;
              tile.disabled = n === 0;
            });

            var liveSizes = 0;
            sizeChips.forEach(function (chip) {
              var band = chip.getAttribute('data-size');
              var n = band === 'all'
                ? cards.length
                : cards.filter(function (c) { return c.getAttribute('data-band') === band; }).length;
              var out = chip.querySelector('[data-size-n]');
              if (out) out.textContent = n ? ' ' + n : '';
              if (band === 'all') return;
              chip.hidden = n === 0;
              chip.disabled = n === 0;
              if (n > 0) liveSizes++;
            });
            /* Only a minority of these titles carry a size at all, so the whole row
               goes when there is nothing to choose between. */
            if (sizeRow) sizeRow.hidden = liveSizes === 0;

            var liveChars = 0;
            charChips.forEach(function (chip) {
              var k = chip.getAttribute('data-char');
              if (k === 'all') return;
              var n = cards.filter(function (c) { return charsOf(c).indexOf(k) > -1; }).length;
              var out = chip.querySelector('[data-char-n]');
              if (out) out.textContent = n ? ' ' + n : '';
              chip.hidden = n === 0;
              chip.disabled = n === 0;
              if (n > 0) liveChars++;
            });
            /* One name is not a filter, it is a fact about the only product there. */
            if (charRow) charRow.hidden = liveChars < 2;
          }

          function paintTiles() {
            tiles.forEach(function (t) {
              t.setAttribute('aria-pressed', activeCats.indexOf(t.getAttribute('data-token')) > -1 ? 'true' : 'false');
            });
            sizeChips.forEach(function (c) {
              c.setAttribute('aria-pressed', c.getAttribute('data-size') === activeSize ? 'true' : 'false');
            });
            charChips.forEach(function (c) {
              c.setAttribute('aria-pressed', c.getAttribute('data-char') === activeChar ? 'true' : 'false');
            });
          }

          tiles.forEach(function (tile) {
            tile.addEventListener('click', function () {
              if (tile.disabled) return;
              var token = tile.getAttribute('data-token');
              var at = activeCats.indexOf(token);
              if (at > -1) activeCats.splice(at, 1); else activeCats.push(token);
              paintTiles(); apply();
            });
          });
          sizeChips.forEach(function (chip) {
            chip.addEventListener('click', function () {
              if (chip.disabled) return;
              activeSize = chip.getAttribute('data-size');
              paintTiles(); apply();
            });
          });
          charChips.forEach(function (chip) {
            chip.addEventListener('click', function () {
              if (chip.disabled) return;
              var k = chip.getAttribute('data-char');
              activeChar = (activeChar === k) ? 'all' : k;
              paintTiles(); apply();
            });
          });


          /* ---------------- sorting ---------------- */
          function num(el, attr) { var v = parseFloat(el.getAttribute(attr)); return isNaN(v) ? 0 : v; }
          function applySort() {
            if (!grid || !sortSel) return;
            var mode = sortSel.value;
            var list = cards.slice();
            list.sort(function (a, b) {
              if (mode === 'price_asc') return num(a, 'data-price') - num(b, 'data-price');
              if (mode === 'price_desc') return num(b, 'data-price') - num(a, 'data-price');
              /* Unsized pieces sort last either way rather than pretending to be 0cm. */
              if (mode === 'size_asc' || mode === 'size_desc') {
                var ca = num(a, 'data-cm') || 99999, cb = num(b, 'data-cm') || 99999;
                if (ca === 99999 && cb === 99999) return num(a, 'data-pos') - num(b, 'data-pos');
                if (ca === 99999) return 1;
                if (cb === 99999) return -1;
                return mode === 'size_asc' ? ca - cb : cb - ca;
              }
              return num(a, 'data-pos') - num(b, 'data-pos');
            });
            list.forEach(function (c) { grid.appendChild(c); });
          }
          if (sortSel) sortSel.addEventListener('change', applySort);

          /* ---------------- quick add ---------------- */
          root.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-add]');
            if (!btn || !root.contains(btn)) return;
            e.preventDefault();
            var card = btn.closest('[data-card]');
            var id = card && card.getAttribute('data-vid');
            if (!id) { if (card) window.location.href = card.getAttribute('data-url'); return; }

            btn.classList.add('is-busy');
            fetch(rootUrl() + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
            })
              .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
              .then(function (res) {
                if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add');
                showToast(cfg.added || 'Added to your cart', cfg.cartUrl);
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
              })
              .catch(function (err) { showToast(err.message || 'Sorry, that could not be added', card.getAttribute('data-url')); })
              .then(function () { btn.classList.remove('is-busy'); });
          });

          counts();
          paintTiles();
          paintWatch();
          apply();

          root.llpzDestroy = function () {
            document.removeEventListener('ll:watchlist:change', syncWatchFromStore);
            window.removeEventListener('storage', onWatchStorage);
            clearTimeout(toastTimer);
            root.dataset.llpzReady = '';
          };
        }

        function find() { return document.querySelector('[data-llpz-root][data-section-id="' + ROOT_ID + '"]'); }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () { boot(find()); });
        } else { boot(find()); }
        document.addEventListener('shopify:section:load', function (e) {
          if (String(e.detail.sectionId) !== ROOT_ID) return;
          boot(find());
        });
        document.addEventListener('shopify:section:unload', function (e) {
          if (String(e.detail.sectionId) !== ROOT_ID) return;
          var el = find();
          if (el && el.llpzDestroy) el.llpzDestroy();
        });
    }

    function initOnce(id) {
      if (!id || inited[id]) return;
      inited[id] = true;
      initInstance(id);
    }

    function bootAll() {
      var roots = document.querySelectorAll("[data-llpz-root][data-section-id]");
      for (var i = 0; i < roots.length; i++) initOnce(roots[i].getAttribute("data-section-id"));
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootAll);
    } else {
      bootAll();
    }

    /* A section added in the theme editor arrives after first boot. Each
       instance registers its own load/unload handlers inside initInstance,
       so this only has to catch ids that have never been seen. */
    document.addEventListener("shopify:section:load", bootAll);
    document.addEventListener("shopify:section:unload", function (e) {
      var id = e && e.detail && String(e.detail.sectionId);
      if (id) delete inited[id];
    });
  })();

  /* ---- block 2 of 2, extracted verbatim ---- */
  (function () {
    var inited = {};

    function initInstance(ROOT_ID) {
      /* Slide affordance: an edge fade that follows real scroll position, plus a
           progress readout so "there is more" is unmistakable. Additive only - it
           reads scroll offsets and writes one attribute. */
        var SELS = [".llpz__grid", ".llpz__tiles"];
        var LABEL = "Swipe plushies";
        var root = document.getElementById('shopify-section-' + ROOT_ID);
        if (!root) return;

        var mq = window.matchMedia('(max-width: 700px)');

        function railList() {
          var out = [];
          for (var i = 0; i < SELS.length; i++) {
            var found = root.querySelectorAll(SELS[i]);
            for (var j = 0; j < found.length; j++) out.push(found[j]);
          }
          return out;
        }

        function barFor(el) {
          var b = el.nextElementSibling;
          if (b && b.className === 'll-swipebar') return b;
          b = document.createElement('span');
          b.className = 'll-swipebar';
          b.setAttribute('aria-hidden', 'true');
          var lab = document.createElement('b');
          lab.textContent = LABEL;
          var track = document.createElement('u');
          track.appendChild(document.createElement('i'));
          b.appendChild(lab);
          b.appendChild(track);
          if (el.parentNode) el.parentNode.insertBefore(b, el.nextSibling);
          return b;
        }

        function sync(el) {
          var bar = barFor(el);
          var over = el.scrollWidth - el.clientWidth;
          if (!mq.matches || over <= 4) {
            el.removeAttribute('data-swipe');
            bar.hidden = true;
            return;
          }
          bar.hidden = false;
          var left = el.scrollLeft > 4;
          var right = el.scrollLeft < over - 4;
          el.setAttribute('data-swipe', left && right ? 'both' : (left ? 'left' : 'right'));

          var w = Math.max(18, (el.clientWidth / el.scrollWidth) * 100);
          var frac = el.scrollLeft / over;
          var thumb = bar.querySelector('i');
          thumb.style.width = w.toFixed(1) + '%';
          thumb.style.transform = 'translateX(' + (((100 - w) / w) * 100 * frac).toFixed(1) + '%)';
        }

        function boot() {
          railList().forEach(function (el) {
            if (el.__llSwipe) { sync(el); return; }
            el.__llSwipe = 1;
            var raf = 0;
            el.addEventListener('scroll', function () {
              if (raf) return;
              raf = requestAnimationFrame(function () { raf = 0; sync(el); });
            }, { passive: true });
            if (window.ResizeObserver) new ResizeObserver(function () { sync(el); }).observe(el);
            sync(el);
          });
        }

        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
        else boot();
        window.addEventListener('resize', boot);
        window.addEventListener('load', boot);
        document.addEventListener('shopify:section:load', boot);
    }

    function initOnce(id) {
      if (!id || inited[id]) return;
      inited[id] = true;
      initInstance(id);
    }

    function bootAll() {
      var roots = document.querySelectorAll("[data-llpz-root][data-section-id]");
      for (var i = 0; i < roots.length; i++) initOnce(roots[i].getAttribute("data-section-id"));
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootAll);
    } else {
      bootAll();
    }

    /* A section added in the theme editor arrives after first boot. Each
       instance registers its own load/unload handlers inside initInstance,
       so this only has to catch ids that have never been seen. */
    document.addEventListener("shopify:section:load", bootAll);
    document.addEventListener("shopify:section:unload", function (e) {
      var id = e && e.detail && String(e.detail.sectionId);
      if (id) delete inited[id];
    });
  })();
})();
